import { callApi } from '@/api/callApi';
import { API_ENDPOINT, API_URL } from '@/api/constant';
import { IFormData, IFormResponse, IFormViewResponse } from '@/interfaces/form.model';
import { IFilter } from '@/interfaces/common.model';
import { getFilterUrl } from '@/utility/helper';

export const FormService = {
  getForms: async (filter: IFilter): Promise<IFormResponse> => {
    const API = `${API_URL}${API_ENDPOINT.getForms}?${getFilterUrl(filter)}`;
    return callApi<IFormResponse>(API, { method: 'GET' });
  },

  getFormById: async (id: string): Promise<IFormViewResponse> => {
    const API = `${API_URL}${API_ENDPOINT.getFormById}/${id}`;
    return callApi<IFormViewResponse>(API, { method: 'GET' });
  },

  createForm: async (formData: Partial<IFormData>): Promise<IFormResponse> => {
    const API = `${API_URL}${API_ENDPOINT.createForm}`;
    return callApi<IFormResponse>(API, {
      method: 'POST',
      data: formData,
    });
  },

  formSubmission: async (formData: Partial<IFormData>): Promise<IFormResponse> => {
    const API = `${API_URL}${API_ENDPOINT.formSubmission}`;
    return callApi<IFormResponse>(API, {
      method: 'POST',
      data: formData,
    });
  },

  updateForm: async (
    id: string,
    data: Partial<IFormData>,
  ): Promise<IFormResponse> => {
    const API = `${API_URL}${API_ENDPOINT.updateForm}/${id}`;
    return callApi<IFormResponse>(API, {
      method: 'PUT',
      data,
    });
  },

  deleteForm: async (id: string): Promise<IFormResponse> => {
    const API = `${API_URL}${API_ENDPOINT.deleteForm}/${id}`;
    return callApi<IFormResponse>(API, {
      method: 'DELETE',
    });
  },
};
